import { useSelector, useDispatch } from 'react-redux';
import XcolumnFunc from '@/pcomponents/common/xcolumn/xcolumn/xcolumn_func';
import MyScreenFunc from '@/pcomponents/common/screen/func/screen_func';

function SearchArea(props: any) {
  let myProps = {
    listOpt: {},
    list: (inData: any) => { },
    ...props
  };
  let user = useSelector((state: any) => state.user);
  let is_show_del_btn = true;
  if (myProps.listOpt.s_open_group == "main") {
    if (user.comp_seq != "4") {
      is_show_del_btn = false;
    }
  }
  let is_under_width = MyScreenFunc.get_is_under();
  let select_option_arr = XcolumnFunc.getSortByTableKey({ 'table': 'study_title', 'key': 'a_subject_sort' });

  const on_change_search_input = (e: any) => {
    let name = e.target.name;
    let value = e.target.value;
    let change_list_opt: any = { now_page: 1 };
    change_list_opt[name] = value;
    myProps.list(change_list_opt);
  };

  let right_box_class_name="absolute right-0 btn-box-right";
  if(is_under_width){
    right_box_class_name="btn-box-right";
  }

  return (
    <div className="search-box btn-box-left relative">
      <select className='search-input' value={myProps.listOpt.s_subject} name='s_subject'
        onChange={on_change_search_input} style={{ width: 70 }} >
        <option value="">과목</option>
        {select_option_arr.map((item: any, idx: number) => {
          return (
            <option key={idx} value={item.value}>{item.text}</option>
          );
        })}
      </select>
      <select className="search-input_select" value={myProps.listOpt.s_category_seq}
        style={{ width: 90 }}
        onChange={(e: any) => {
          myProps.list({
            "now_page": 1,
            "s_category_seq": e.target.value
          });
        }}>
        <option value="">카테고리</option>
        {
          myProps.categoryInfoArr.map((item: any, idx: number) => {
            return (
              <option key={idx} value={item.a_seq}>{item.a_title}</option>
            );
          })
        }
      </select>
      <label>
        <input type="checkbox" checked={myProps.listOpt.s_open_group == "main"}
          onChange={(e: any) => {
            let change_open_group = "";
            let s_textbook_in_now_period="";
            if (e.target.checked) {
              change_open_group = "main";
              if(user.comp_seq!="4"){
                s_textbook_in_now_period="1";
              }
            }
            myProps.list({
              "now_page": 1,
              "s_open_group": change_open_group,
              "s_textbook_in_now_period":s_textbook_in_now_period
            });
          }} /> 공통
      </label>
      <div className={right_box_class_name}>
        <input type="text" name="s_title_like" value={myProps.listOpt.s_title_like}
          autoComplete='off' placeholder="제목"
          className='searh-input' onChange={on_change_search_input} style={{ width: 70 }}
        />
        <button className="btn btn-dark" onClick={() => { myProps.list({}); }}>검색</button>
        <button className="btn btn-dark" onClick={() => { myProps.setWriteState(); }}>신규</button>
        {is_show_del_btn &&
          <button className="btn btn-dark" onClick={myProps.goDelete}>삭제</button>
        }
      </div>
    </div>
  );
};
export default SearchArea;